import { StringMap } from '@/shared/utils/map'

export function getProperty(input: StringMap<any>, selector: string): any {
  const path: string[] = selector.split('.')
  let result: any = input

  for (const part of path) {
    if (result.hasOwnProperty(part)) {
      result = result[part]
    } else {
      result = undefined
    }
  }

  return result
}
